import css from './Card.module.css';
import classNames from 'classnames';

export const Card = ({ children, className }) => {
  const classes = classNames(css.card, className);
  return <div className={classes}>{children}</div>;
};
